import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import CommunityActions from '~/actions/community';
import { convertUrl, getHtmlIframes, getHtmlImages } from '~/services/util';

const Card = ({ avatar, user, date, title, thumbnail, description, loginUser, special = null, stats, onClick, onSelect }) => {
    const iframes = getHtmlIframes(description);
    const options = stats?.flag ? ['Unflag spam'] : ['Flag spam'];

    return (
        <div className="card cursor-pointer mt-2" onClick={onClick}>
            {special && <p className="dsl-b22 bold mt-3 mt-md-0">{special}</p>}
            <div className="d-h-between mt-2 mt-md-0">
                <div className="d-h-start">
                    <Avatar className="mr-2" url={avatar} isSponsored={true} />
                    <div>
                        <p className="dsl-m12 mb-1">
                            {user?.first_name} {user?.last_name}
                        </p>
                        <p className="dsl-b12 mb-0">{user?.profile?.company}</p>
                    </div>
                </div>
                <div className="d-flex">
                    <span className="dsl-m12">{date}</span>
                    {loginUser.id && loginUser.id !== user.id && <EditDropdown className="ml-3" options={options} onChange={onSelect} />}
                </div>
            </div>
            <p className="dsl-b16 bold mt-4">{title}</p>
            <div className="d-h-center blog-thumbnail w-100 pb-2" dangerouslySetInnerHTML={{ __html: thumbnail }} />
            {!thumbnail && !iframes.length && <Thumbnail size="responsive" />}
            {iframes?.map((iframe, idx) => (
                <div key={idx} className="blog-iframe w-100 dsl-b11 text-500" dangerouslySetInnerHTML={{ __html: iframe }} />
            ))}
            <div className="d-h-end">
                <Button className="p-0" type="link" name="Read more" />
            </div>
        </div>
    );
};

const Recent = ({ data, onClick }) => {
    if (!data.posts || data.posts?.data?.length === 0) {
        return <p className="dsl-m12 mt-4 text-center">No posts to display.</p>;
    }

    const dispatch = useDispatch();
    const loginUser = useSelector((state) => state.app.user?.community_user) || {};

    const handlePagination = (e) => {
        dispatch(CommunityActions.getblogdetailsRequest(data.user_id, { blogId: data.blog?.id, page: e }));
    };

    const handleSetFlag = (item) => (e) => {
        const after = {
            type: 'GETBLOGDETAILS_REQUEST',
            userId: data.user_id,
            payload: { blogId: data.blog?.id, page },
        };
        const payload = { contentId: item.id, flag: 'spam' };
        dispatch(CommunityActions.postcontentflagRequest(payload, null, after));
    };

    const page = data.posts?.current_page || 1;
    const total = data.posts?.last_page || 1;

    return (
        <>
            {data?.posts?.data?.map((item, index) => (
                <Card
                    key={`posts-${item.id}-${index}`}
                    special={index === 0 ? 'Recent' : ''}
                    user={item?.author}
                    loginUser={loginUser}
                    avatar={convertUrl(item?.author_avatar)}
                    date={moment(item.updated_at).format('MMM DD, YY')}
                    thumbnail={getHtmlImages(item.data.body)[0]}
                    title={item.name}
                    stats={item.stats}
                    description={item.data.body}
                    onClick={() => onClick(item)}
                    onSelect={handleSetFlag(item)}
                />
            ))}
            <Pagination current={page} pers={[]} total={total} onChange={handlePagination} />
        </>
    );
};

Recent.propTypes = {
    data: PropTypes.shape({
        user_id: PropTypes.number,
        blog: PropTypes.shape({
            id: PropTypes.number,
        }),
        posts: PropTypes.shape({
            current_page: PropTypes.number,
            data: PropTypes.array,
            last_page: PropTypes.number,
        }),
    }),
};

Recent.defaultProps = {
    data: {
        user_id: 0,
        blog: {
            id: 0,
        },
        posts: {
            current_page: 0,
            data: [],
            last_page: 0,
        },
    },
};

export default Recent;
